module.exports = __webpack_public_path__ + "img/Banner-Web_1350.e8a368e5.jpg";